import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5adbbcbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"4%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"11%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"17%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"9%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"28%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"11%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} })
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ID", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" サブカテゴリ ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 掲載期間 ")
], -1))
const _hoisted_15 = ["max"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin":"0rem 0.2rem"} }, "～", -1))
const _hoisted_17 = ["max"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 最終更新日付 ")
], -1))
const _hoisted_19 = ["max"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "form-control-title"
}, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" タイトル ")
], -1))
const _hoisted_21 = { colspan: "2" }
const _hoisted_22 = {
  colspan: "1",
  style: {"text-align":"right"}
}
const _hoisted_23 = {
  key: 1,
  for: "chkJyuyo",
  class: "form-check-label"
}
const _hoisted_24 = { colspan: "3" }
const _hoisted_25 = ["disabled", "max"]
const _hoisted_26 = {
  key: 1,
  style: {"margin":"0rem 0.2rem"}
}
const _hoisted_27 = ["disabled", "max"]
const _hoisted_28 = { class: "form-inline flex-container" }
const _hoisted_29 = {
  class: "form-group",
  style: {"width":"35%","margin-right":"1rem"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "表示対象", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAll",
  class: "form-check-label"
}, "全員", -1))
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAgSegment",
  class: "form-check-label"
}, " エージェントセグメント ", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = ["value"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rdoAg",
  class: "form-check-label"
}, " 個別エージェント ", -1))
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "AGコード", -1))
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { class: "file-upload" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["accept", "disabled"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = {
  class: "form-group",
  style: {"width":"65%","min-height":"210px"}
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "本文", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"22%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"42%"} })
  ])
], -1))
const _hoisted_58 = {
  key: 0,
  class: "form-control-title"
}
const _hoisted_59 = { key: 1 }
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = {
  key: 2,
  class: "form-control-title"
}
const _hoisted_62 = { key: 3 }
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"27%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"40%"} })
  ])
], -1))
const _hoisted_65 = { colspan: "4" }
const _hoisted_66 = { class: "file-upload" }
const _hoisted_67 = ["accept"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "添付ファイル説明", -1))
const _hoisted_70 = { colspan: "4" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = { colspan: "4" }
const _hoisted_73 = { class: "file-upload" }
const _hoisted_74 = ["accept"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "画像ファイル説明", -1))
const _hoisted_77 = { colspan: "4" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { colspan: "4" }
const _hoisted_80 = { class: "file-upload" }
const _hoisted_81 = ["accept"]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "動画ファイル説明", -1))
const _hoisted_84 = { colspan: "4" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode(" 検索用タグ ")
], -1))
const _hoisted_87 = ["value"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "管理用タグ", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }),
  /*#__PURE__*/_createElementVNode("td", null, "※タグはカンマ区切りで入力してください")
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"40%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} })
], -1))
const _hoisted_91 = { style: {"text-align":"left"} }
const _hoisted_92 = { style: {"text-align":"center"} }
const _hoisted_93 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ContentsPreviewComponent = _resolveComponent("ContentsPreviewComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.contentsCaategoryName) + "更新 ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.contentsCaategoryName) + "登録", 1)
                    ], 64))
              ]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("table", null, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_10,
                    _createElementVNode("td", null, _toDisplayString(_ctx.contentsData.contentsId), 1),
                    _hoisted_11,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("select", {
                        id: "cmbSubCategory",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentsData.subCategoryId) = $event)),
                        ref: "cmbSubCategory"
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategoryList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.subCategoryId,
                            value: item.subCategoryId
                          }, _toDisplayString(item.subCategoryName), 9, _hoisted_13))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.contentsData.subCategoryId]
                      ])
                    ]),
                    _hoisted_14,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtDispDtFrom",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentsData.keisaiKikanStart) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_15), [
                        [_vModelText, _ctx.contentsData.keisaiKikanStart]
                      ]),
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtDispDtTo",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentsData.keisaiKikanEnd) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_17), [
                        [_vModelText, _ctx.contentsData.keisaiKikanEnd]
                      ])
                    ]),
                    _hoisted_18,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "txtLastUpdDt",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentsData.lastUpdate) = $event)),
                        max: _ctx.AppConstants.MAX_DATE_VALUE
                      }, null, 8, _hoisted_19), [
                        [_vModelText, _ctx.contentsData.lastUpdate]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_20,
                    _createElementVNode("td", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "txtTitle",
                        maxlength: "255",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentsData.title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.contentsData.title]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      (!_ctx.isOneStopGide)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "checkbox",
                            id: "chkJyuyo",
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contentsData.jyuyoFlg) = $event)),
                            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChangeJyuyoFlg && _ctx.onChangeJyuyoFlg(...args)))
                          }, null, 544)), [
                            [_vModelCheckbox, _ctx.contentsData.jyuyoFlg]
                          ])
                        : _createCommentVNode("", true),
                      (!_ctx.isOneStopGide)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_23, "重要"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      (!_ctx.isOneStopGide)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            type: "date",
                            id: "txtJyuyoKikanFrom",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.contentsData.jyuyoKikanStart) = $event)),
                            disabled: !_ctx.contentsData.jyuyoFlg,
                            max: _ctx.AppConstants.MAX_DATE_VALUE
                          }, null, 8, _hoisted_25)), [
                            [_vModelText, _ctx.contentsData.jyuyoKikanStart]
                          ])
                        : _createCommentVNode("", true),
                      (!_ctx.isOneStopGide)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_26, "～"))
                        : _createCommentVNode("", true),
                      (!_ctx.isOneStopGide)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 2,
                            type: "date",
                            id: "txtJyuyoKikanTo",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contentsData.jyuyoKikanEnd) = $event)),
                            disabled: !_ctx.contentsData.jyuyoFlg,
                            max: _ctx.AppConstants.MAX_DATE_VALUE
                          }, null, 8, _hoisted_27)), [
                            [_vModelText, _ctx.contentsData.jyuyoKikanEnd]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("fieldset", null, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAll",
                        name: "hyojiTaisho",
                        value: _ctx.ContentRegConstants.HYOJI_TAISHO_ALL,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.contentsData.hyojiTaisho) = $event)),
                        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_32), [
                        [_vModelRadio, _ctx.contentsData.hyojiTaisho]
                      ]),
                      _hoisted_33
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAgSegment",
                        name: "hyojiTaisho",
                        value: _ctx.ContentRegConstants.HYOJI_TAISHO_AG_SEGMENT,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.contentsData.hyojiTaisho) = $event)),
                        onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_35), [
                        [_vModelRadio, _ctx.contentsData.hyojiTaisho]
                      ]),
                      _hoisted_36
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("select", {
                        id: "cmbAgSegment",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.contentsData.agSegmentId) = $event)),
                        disabled: !_ctx.isHyojiTaishoAgSegment
                      }, [
                        _hoisted_39,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agSegmentList, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.agSegmentCode,
                            value: item.agSegmentCode
                          }, _toDisplayString(item.agSegmentCode) + "：" + _toDisplayString(item.agSegmentName), 9, _hoisted_40))
                        }), 128))
                      ], 8, _hoisted_38), [
                        [_vModelSelect, _ctx.contentsData.agSegmentId]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "rdoAg",
                        name: "hyojiTaisho",
                        value: _ctx.ContentRegConstants.HYOJI_TAISHO_AG_CODE,
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contentsData.hyojiTaisho) = $event)),
                        onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onChangeHyojiTaisho && _ctx.onChangeHyojiTaisho(...args)))
                      }, null, 40, _hoisted_42), [
                        [_vModelRadio, _ctx.contentsData.hyojiTaisho]
                      ]),
                      _hoisted_43
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "txtAgCode",
                        maxlength: "8",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.contentsData.agCode) = $event)),
                        disabled: 
                    !_ctx.isHyojiTaishoAgCode || _ctx.contentsData.agCodeList.length > 0
                  
                      }, null, 8, _hoisted_46), [
                        [_vModelText, _ctx.contentsData.agCode]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("button", {
                          class: _normalizeClass([
                      'btn',
                      'btn-sm',
                      _ctx.isHyojiTaishoAgCode ? 'btn-primary' : 'btn-secondary',
                    ]),
                          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onAgCodeFileUpload && _ctx.onAgCodeFileUpload(...args))),
                          disabled: !_ctx.isHyojiTaishoAgCode
                        }, " アップロード ", 10, _hoisted_49),
                        _createElementVNode("input", {
                          type: "file",
                          accept: _ctx.hyojiTaishoExtensions.join(','),
                          onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleAgCodeFileUpload && _ctx.handleAgCodeFileUpload(...args))),
                          disabled: !_ctx.isHyojiTaishoAgCode,
                          ref: "agCodeFileInput",
                          style: {"display":"none"}
                        }, null, 40, _hoisted_50)
                      ]),
                      _withDirectives(_createElementVNode("label", { style: {"margin-left":"1rem"} }, _toDisplayString(_ctx.getValueAgCodeUploadCnt), 513), [
                        [_vShow, _ctx.contentsData.agCodeList.length > 0]
                      ])
                    ]),
                    (!_ctx.isOneStopGide)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("button", {
                            class: _normalizeClass([
                    'btn',
                    'btn-sm',
                    _ctx.isEditModeUpdate ? 'btn-primary' : 'btn-secondary',
                  ]),
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onSendMail(false))),
                            disabled: !_ctx.isEditModeUpdate
                          }, " 通知メール送信 ", 10, _hoisted_52),
                          _createElementVNode("button", {
                            class: _normalizeClass([
                    'btn',
                    'btn-sm',
                    _ctx.isEditModeUpdate ? 'btn-primary' : 'btn-secondary',
                  ]),
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onSendMail(true))),
                            disabled: !_ctx.isEditModeUpdate
                          }, " 通知メール送信（管理者のみ） ", 10, _hoisted_53)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _hoisted_56,
                  _createVNode(_component_QuillEditor, {
                    id: "rtxtHonbun",
                    "onUpdate:content": _ctx.handleContentUpdate,
                    modelValue: _ctx.contentsData.body,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.contentsData.body) = $event)),
                    style: _normalizeStyle({ height: _ctx.isOneStopGide ? '210px' : '250px' })
                  }, null, 8, ["onUpdate:content", "modelValue", "style"])
                ])
              ]),
              _createElementVNode("table", null, [
                _hoisted_57,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsLinkList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.rowNo
                    }, [
                      (index == 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_58, " リンクキャプション "))
                        : (_openBlock(), _createElementBlock("td", _hoisted_59)),
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.caption) = $event)
                        }, null, 8, _hoisted_60), [
                          [_vModelText, item.caption]
                        ])
                      ]),
                      (index == 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_61, "リンクURL"))
                        : (_openBlock(), _createElementBlock("td", _hoisted_62)),
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                        }, null, 8, _hoisted_63), [
                          [_vModelText, item.url]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("table", null, [
                _hoisted_64,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: _normalizeClass([
                  'form-control-title',
                  { 'vertical-align-top': _ctx.hasContentsTempFile },
                ])
                    }, " 添付ファイル ", 2),
                    _createElementVNode("td", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (
                      _ctx.onContentsFileUpload(
                        _ctx.ContentRegConstants.TRIGGER_TEMP_FILE
                      )
                    ))
                        }, " + "),
                        _createElementVNode("input", {
                          type: "file",
                          accept: _ctx.tempFileExtensions.join(','),
                          onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                          ref: "tempFileInput",
                          style: {"display":"none"}
                        }, null, 40, _hoisted_67)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsTempFileList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.rowNo
                        }, [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-sm",
                            onClick: ($event: any) => (
                      _ctx.onRemoveContentsFile(
                        item.rowNo,
                        _ctx.ContentRegConstants.TRIGGER_TEMP_FILE
                      )
                    )
                          }, " - ", 8, _hoisted_68),
                          _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_69,
                    _createElementVNode("td", _hoisted_70, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.contentsData.contentsTempFileExp) = $event)),
                        disabled: !_ctx.hasContentsTempFile
                      }, null, 8, _hoisted_71), [
                        [_vModelText, _ctx.contentsData.contentsTempFileExp]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: _normalizeClass([
                  'form-control-title',
                  { 'vertical-align-top': _ctx.hasContentsImgFile },
                ])
                    }, " 画像ファイル ", 2),
                    _createElementVNode("td", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (
                      _ctx.onContentsFileUpload(_ctx.ContentRegConstants.TRIGGER_IMG_FILE)
                    ))
                        }, " + "),
                        _createElementVNode("input", {
                          type: "file",
                          accept: _ctx.imgFileExtensions.join(','),
                          onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                          ref: "imgFileInput",
                          style: {"display":"none"}
                        }, null, 40, _hoisted_74)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsImgList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.rowNo
                        }, [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-sm",
                            onClick: ($event: any) => (
                      _ctx.onRemoveContentsFile(
                        item.rowNo,
                        _ctx.ContentRegConstants.TRIGGER_IMG_FILE
                      )
                    )
                          }, " - ", 8, _hoisted_75),
                          _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_76,
                    _createElementVNode("td", _hoisted_77, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.contentsData.contentsImgFileExp) = $event)),
                        disabled: !_ctx.hasContentsImgFile
                      }, null, 8, _hoisted_78), [
                        [_vModelText, _ctx.contentsData.contentsImgFileExp]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      class: _normalizeClass([
                  'form-control-title',
                  { 'vertical-align-top': _ctx.hasContentsVideoFile },
                ])
                    }, " 動画ファイル ", 2),
                    _createElementVNode("td", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("button", {
                          class: "btn btn-primary btn-sm",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (
                      _ctx.onContentsFileUpload(
                        _ctx.ContentRegConstants.TRIGGER_VIDEO_FILE
                      )
                    ))
                        }, " + "),
                        _createElementVNode("input", {
                          type: "file",
                          accept: _ctx.videoFileExtensions.join(','),
                          onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                          ref: "videoFileInput",
                          style: {"display":"none"}
                        }, null, 40, _hoisted_81)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentsData.contentsVideoList, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.rowNo
                        }, [
                          _createElementVNode("button", {
                            class: "btn btn-danger btn-sm",
                            onClick: ($event: any) => (
                      _ctx.onRemoveContentsFile(
                        item.rowNo,
                        _ctx.ContentRegConstants.TRIGGER_VIDEO_FILE
                      )
                    )
                          }, " - ", 8, _hoisted_82),
                          _createTextVNode(" " + _toDisplayString(item.fileName), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_83,
                    _createElementVNode("td", _hoisted_84, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "255",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.contentsData.contentsVideoFileExp) = $event)),
                        disabled: !_ctx.hasContentsVideoFile
                      }, null, 8, _hoisted_85), [
                        [_vModelText, _ctx.contentsData.contentsVideoFileExp]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_86,
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary btn-sm",
                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.openKensakuTagModal && _ctx.openKensakuTagModal(...args)))
                      }, " + "),
                      _createVNode(_component_Modal, {
                        isOpen: _ctx.isOpenKensakuTagModal,
                        tags: _ctx.kensakuTagModalodalTags,
                        onClose: _ctx.closeKensakuTagModal,
                        onUpdateTags: _ctx.updateKensakuTags
                      }, null, 8, ["isOpen", "tags", "onClose", "onUpdateTags"])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        readonly: "true",
                        value: _ctx.getValueKensakuTag
                      }, null, 8, _hoisted_87)
                    ]),
                    _hoisted_88,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "500",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.contentsData.kanriTag) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.contentsData.kanriTag]
                      ])
                    ])
                  ]),
                  _hoisted_89
                ])
              ]),
              _createElementVNode("table", null, [
                _hoisted_90,
                _createElementVNode("tbody", null, [
                  _createElementVNode("td", _hoisted_91, [
                    _withDirectives(_createElementVNode("button", {
                      type: "button",
                      name: "btnDelete",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                    }, " 削除 ", 512), [
                      [_vShow, _ctx.isEditModeUpdate]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_92, [
                    _withDirectives(_createElementVNode("button", {
                      type: "button",
                      name: "btnPreview",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
                    }, " プレビュー ", 512), [
                      [_vShow, _ctx.isEditModeUpdate]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_93, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnBack",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                    }, " 戻る "),
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnFixed",
                      class: "btn btn-footer btn-primary",
                      onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
                    }, [
                      (_ctx.isEditModeUpdate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("更新")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("登録")
                          ], 64))
                    ])
                  ])
                ])
              ]),
              (_ctx.isInitComplete)
                ? (_openBlock(), _createBlock(_component_ContentsPreviewComponent, {
                    key: 1,
                    isOpen: _ctx.isOpenPreviewModal,
                    categoryId: _ctx.modalParamValueCategoryId,
                    contentsId: _ctx.modalParamValueContentsId,
                    onClosePreview: _ctx.handlePreviewModalClosed
                  }, null, 8, ["isOpen", "categoryId", "contentsId", "onClosePreview"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}